export interface AuthState {
    token: string | 'NOT_SET',
    remember: boolean
}

export const AUTH_FEATURE_KEY = 'auth';